module.exports = __webpack_public_path__ + "img/SqualoSport-interno8.03072e78.jpeg";